export default __webpack_public_path__ + "static/media/boilerplate.3d62d035.jpg";